import FileComponent from "../fileComponent/_index"

const FolderComponent = (props: any) => {
    return <FileComponent {...props} />;
}

export default FolderComponent;